<div class="content-heading">
  <div class="header-Container">
    <h3>Reporte de Comodato</h3>
    <small>Reporte de comodato</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      <div class="row align-items-end">
        
        <div class="col-lg-4 col-md-5">
          <label class="font-weight-bold">Centro de Ventas</label>
          <ng-autocomplete 
            [placeholder]="'Búsqueda'"
            [data]="nodes"
            [searchKeyword]="inputArgument"
            [itemTemplate]="itemOutputTemplate"
            [notFoundTemplate]="notFoundoutputTemplate"
            [debounceTime]="600"
            [minQueryLength]="3"
            (selected)='selectCeVeEvent($event)'
            (inputCleared)='clearCeVeEvent($event)'
            [(ngModel)]="selectedUnit">
          </ng-autocomplete>
          
          <ng-template #itemOutputTemplate let-item>
            <a [innerHTML]="item.UnitDescription"></a>
          </ng-template>
          <ng-template #notFoundoutputTemplate let-notFound>
            <div [innerHTML]="'No se encontraron coincidencias'"></div>
          </ng-template>
        </div>

        <div class="col-lg-6 col-md-7">
          <aph-custom-date-picker 
            [singleMode]="false" 
            labelInicio="Desde"
            labelFin="Hasta"
            [maxDate]="maxDate"
            mode="date"
            [IsDisabledAll]="downloading"
            (startDateChange)="initialDate = $event"
            (endDateChange)="finalDate = $event"
            (onValidationStatus)="isValidRange = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Descargando...' : 'Descargar reporte'" 
            [loading]="downloading" 
            [disabled]="!isValidRange"
            (btnClick)="btnDowndload()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>